/* Lily & Ruby — colour swatches that link sibling products ("Name - Colour") */
(function () {
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function sized(u, w) { if (!u) return ''; if (/width=/.test(u)) return u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function search(q) {
    return fetch('/search?type=product&q=' + encodeURIComponent(q) + '&section_id=lr-swatch-json', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/<script type="application\/json" data-lr-sw-json>([\s\S]*?)<\/script>/);
        return m ? JSON.parse(m[1]) : [];
      })
      .catch(function () { return []; });
  }

  // 1) exact title phrase, 2) model name only — merged, then filtered on "Base - "
  function fetchSiblings(base) {
    var name = base.split(' ')[0];
    return Promise.all([search('title:"' + base + '"'), search(name)]).then(function (r) { return r[0].concat(r[1]); });
  }

  function init(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var title = el.getAttribute('data-title') || '';
    var handle = el.getAttribute('data-handle');
    var cut = title.lastIndexOf(' - ');
    if (cut < 1) { el.remove(); return; }
    var base = title.slice(0, cut).trim();
    var current = title.slice(cut + 3).trim();
    el.innerHTML = '<p class="lr-sw__label">Color : <span data-lr-sw-name>' + esc(current) + '</span></p><div class="lr-sw__list"></div>';
    var list = el.querySelector('.lr-sw__list');
    var labelName = el.querySelector('[data-lr-sw-name]');
    var me = { handle: handle, title: title, url: el.getAttribute('data-url'), image: el.getAttribute('data-image') };

    function draw(sib) {
      list.innerHTML = sib.map(function (p) {
        var colour = p.title.slice(p.title.lastIndexOf(' - ') + 3);
        var active = p.handle === handle;
        return '<a href="' + esc(p.url || ('/products/' + p.handle)) + '" class="lr-sw__item' + (active ? ' is-active' : '') + '" data-name="' + esc(colour) + '" title="' + esc(colour) + '"' + (active ? ' aria-current="true"' : '') + '>' +
          (p.image ? '<img src="' + esc(sized(p.image, 160)) + '" alt="' + esc(colour) + '" loading="lazy">' : '<span>' + esc(colour) + '</span>') +
          '</a>';
      }).join('');
      list.querySelectorAll('.lr-sw__item').forEach(function (a) {
        a.addEventListener('mouseenter', function () { labelName.textContent = a.getAttribute('data-name'); });
        a.addEventListener('mouseleave', function () { labelName.textContent = current; });
      });
    }

    draw([me]);
    fetchSiblings(base).then(function (ps) {
      var pre = base.toLowerCase() + ' - ';
      var seen = {};
      var sib = ps.filter(function (p) {
        if (!p || !p.title || seen[p.handle]) return false;
        seen[p.handle] = 1;
        return p.title.toLowerCase().indexOf(pre) === 0;
      });
      if (!sib.some(function (p) { return p.handle === handle; })) sib.push(me);
      sib.sort(function (a, b) { return a.title.localeCompare(b.title); });
      draw(sib);
    }).catch(function () {});
  }

  function run() { document.querySelectorAll('[data-lr-sw]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
